import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Wrapper = styled.div`
  min-height: 100vh;
  background-color: #f0f2f5;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Header = styled.header`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 24px;
  background: linear-gradient(135deg, #5882f2 0%, #61e0af 100%);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 32px 16px;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 24px rgba(45, 91, 255, 0.1);
  animation: ${fadeIn} 0.3s ease-out;
`;

export const CardLabel = styled.span`
  font-family: "Graphik-Regular", sans-serif;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #9b9ba8;
  margin-top: 4px;
`;

export const CotacaoValue = styled.span`
  font-family: "Graphik-Regular", sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #1a1a2e;
  letter-spacing: 0.3px;
  text-align: center;
  word-break: break-all;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e0e4f4, transparent);
  margin: 4px 0;
`;

export const OpenButton = styled.button`
  font-family: "Graphik-Regular", sans-serif;
  font-size: 14px;
  color: #ffffff;
  background: linear-gradient(135deg, #5882f2 0%, #61e0af 100%);
  border: none;
  border-radius: 10px;
  padding: 14px 24px;
  width: 100%;
  cursor: pointer;
  letter-spacing: 0.3px;
  margin-top: 4px;

  &:active {
    opacity: 0.85;
  }
`;

export const ErrorText = styled.p`
  font-family: "Graphik-Regular", sans-serif;
  font-size: 14px;
  color: #888;
  text-align: center;
  margin-top: 40px;
  padding: 0 24px;
`;
